import React, { useEffect } from 'react';

import Typography from '../../library/typography/typography';

import { trackAction } from '../../shared/utils/analytics/analytics';

import './customer-service-down-saved-fitments-message.scss';

function CustomerServiceDownSavedFitmentsMessage() {
  const errMsg = {
    firstLine: "We're doing maintenance on this info right now",
    secondLine:
      'Check back soon, use a vehicle from your recent searches, or add a new vehicle to continue shopping!'
  };

  useEffect(() => {
    trackAction('C360_down_messaging', {
      error_msg: `${errMsg.firstLine}. ${errMsg.secondLine}`
    });
  }, [errMsg.firstLine, errMsg.secondLine]);

  return (
    <div styleName="container">
      <Typography variant="h2" weight="heavy">
        {errMsg.firstLine}
      </Typography>
      <Typography>{errMsg.secondLine}</Typography>
    </div>
  );
}

export default CustomerServiceDownSavedFitmentsMessage;
